"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameScene = void 0;
var _CogManager = require("../../utils/CogManager");
var _EventBus = require("../EventBus");
var _BubbleUtils = require("../utils/BubbleUtils");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class GameScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'GameScene'
    });
    //@ts-ignore
    _defineProperty(this, "selectedCogTiltLeftBlock", null);
    _defineProperty(this, "selectedCogTiltRightBlock", null);
    _defineProperty(this, "selectedCogFireBlock", null);
    _defineProperty(this, "isShooting", false);
    // α between 0 (max smoothing cog's acc values,
    //  max lag) and 1 (no smoothing):
    //@ts-ignore
    _defineProperty(this, "alpha", window.alpha || 0.1);
    _defineProperty(this, "smoothAx", 0);
    _defineProperty(this, "smoothAy", 0);
    _defineProperty(this, "bubbleUtils", new _BubbleUtils.BubbleUtils());
    window.gameScene = this; // for debugging purposes
  }
  create() {
    this.bubbleUtils.setCanvasStyle();
    this.bubbleUtils.createBackground(this);
    this.bubbleUtils.createWalls(this);
    this.bubbleUtils.createRestartButton(this);
    this.bubbleUtils.createBubbleElements(this);
    const connectedCog = (0, _CogManager.getConnectedCog)();
    if (connectedCog) {
      this.smoothAx = connectedCog.raftStateInfo.accelerometer.ax;
      this.smoothAy = connectedCog.raftStateInfo.accelerometer.ay;
    }
    this.bubbleUtils.setupInputHandlers(this);
    this.bubbleUtils.loadSounds(this);
    this.bubbleUtils.createScoreText(this);
    _EventBus.EventBus.emit("scene-ready", this);
  }
  update(time, delta) {
    const connectedCog = (0, _CogManager.getConnectedCog)();
    if (connectedCog) {
      var _this$selectedCogTilt, _this$selectedCogTilt2, _this$selectedCogTilt3, _this$selectedCogTilt4, _this$selectedCogTilt5, _this$selectedCogTilt6, _this$selectedCogTilt7, _this$selectedCogTilt8;
      const ay = connectedCog.raftStateInfo.accelerometer.ay;
      const ax = connectedCog.raftStateInfo.accelerometer.ax;
      if (((_this$selectedCogTilt = this.selectedCogTiltLeftBlock) === null || _this$selectedCogTilt === void 0 ? void 0 : _this$selectedCogTilt.block) === "moveleft" && ((_this$selectedCogTilt2 = this.selectedCogTiltRightBlock) === null || _this$selectedCogTilt2 === void 0 ? void 0 : _this$selectedCogTilt2.block) === "moveright") {
        var _this$bubbleUtils$arr, _this$bubbleUtils$ini, _this$selectedCogFire;
        // this is the right conditions so we use cog as steering wheel
        // 1) apply low-pass:
        this.smoothAx += this.alpha * (ax - this.smoothAx);
        this.smoothAy += this.alpha * (ay - this.smoothAy);
        // compute raw angle: zero = right, positive = counter-clockwise
        // but since your arrow art apparently points “up” at zero,
        // we’ll rotate by –90° (–π/2) to compensate.
        const raw = Math.atan2(this.smoothAy, -this.smoothAx); // radians, zero=right, CCW+
        const display = raw - Math.PI / 2; // shift so that (0,1)→up
        (_this$bubbleUtils$arr = this.bubbleUtils.arrow) === null || _this$bubbleUtils$arr === void 0 || _this$bubbleUtils$arr.setRotation(display);
        (_this$bubbleUtils$ini = this.bubbleUtils.initialBubble) === null || _this$bubbleUtils$ini === void 0 || _this$bubbleUtils$ini.setRotation(display);
        this.bubbleUtils.updateProjectionLine(display);
        this.bubbleUtils.updateProtractorArc(display);

        // shoot when cog's button is pressed
        if (((_this$selectedCogFire = this.selectedCogFireBlock) === null || _this$selectedCogFire === void 0 ? void 0 : _this$selectedCogFire.block) === "fire") {
          var _publishedDataAnalyse;
          const isCogButtonPressed = (_publishedDataAnalyse = connectedCog.publishedDataAnalyser.cogState) === null || _publishedDataAnalyse === void 0 ? void 0 : _publishedDataAnalyse.buttonClick;
          if (isCogButtonPressed === "click" && ay > 0 && !this.isShooting) {
            this.bubbleUtils.shootBubble(this);
            this.isShooting = true;
          } else if (isCogButtonPressed === "release") {
            this.isShooting = false;
          }
        }
      }
      if (((_this$selectedCogTilt3 = this.selectedCogTiltLeftBlock) === null || _this$selectedCogTilt3 === void 0 ? void 0 : _this$selectedCogTilt3.block) === "moveleft" && ((_this$selectedCogTilt4 = this.selectedCogTiltRightBlock) === null || _this$selectedCogTilt4 === void 0 ? void 0 : _this$selectedCogTilt4.block) === "moveleft") {
        var _this$bubbleUtils$arr2, _this$bubbleUtils$ini2, _this$selectedCogFire2;
        // when cog is steered left, the arrow rotates correctly to the left, but when steered right, it rotates to the left again. so basically it only steers left

        // ————— only steer left —————
        // 1) apply low-pass to the *raw* readings
        this.smoothAx += this.alpha * (ax - this.smoothAx);
        this.smoothAy += this.alpha * (ay - this.smoothAy);

        // 2) clamp the X to always be negative (–1..0)
        const sanitizedAx = -Math.abs(this.smoothAx);

        // 3) build angle exactly as before, but using sanitized
        const raw = Math.atan2(this.smoothAy, -sanitizedAx);
        const display = raw - Math.PI / 2;
        (_this$bubbleUtils$arr2 = this.bubbleUtils.arrow) === null || _this$bubbleUtils$arr2 === void 0 || _this$bubbleUtils$arr2.setRotation(display);
        (_this$bubbleUtils$ini2 = this.bubbleUtils.initialBubble) === null || _this$bubbleUtils$ini2 === void 0 || _this$bubbleUtils$ini2.setRotation(display);
        this.bubbleUtils.updateProjectionLine(display);
        this.bubbleUtils.updateProtractorArc(display);
        if (((_this$selectedCogFire2 = this.selectedCogFireBlock) === null || _this$selectedCogFire2 === void 0 ? void 0 : _this$selectedCogFire2.block) === "fire") {
          var _publishedDataAnalyse2;
          const isCogButtonPressed = (_publishedDataAnalyse2 = connectedCog.publishedDataAnalyser.cogState) === null || _publishedDataAnalyse2 === void 0 ? void 0 : _publishedDataAnalyse2.buttonClick;
          if (isCogButtonPressed === "click" && ay > 0 && !this.isShooting) {
            this.bubbleUtils.shootBubble(this);
            this.isShooting = true;
          } else if (isCogButtonPressed === "release") {
            this.isShooting = false;
          }
        }
      }
      if (((_this$selectedCogTilt5 = this.selectedCogTiltLeftBlock) === null || _this$selectedCogTilt5 === void 0 ? void 0 : _this$selectedCogTilt5.block) === "moveright" && ((_this$selectedCogTilt6 = this.selectedCogTiltRightBlock) === null || _this$selectedCogTilt6 === void 0 ? void 0 : _this$selectedCogTilt6.block) === "moveright") {
        var _this$bubbleUtils$arr3, _this$bubbleUtils$ini3, _this$selectedCogFire3;
        // when cog is steered right, the arrow rotates correctly to the right, but when steered left, it rotates to the right again. so basically it only steers right

        // ————— only steer right —————
        // 1) apply low-pass
        this.smoothAx += this.alpha * (ax - this.smoothAx);
        this.smoothAy += this.alpha * (ay - this.smoothAy);

        // 2) clamp the X to always be positive (0..+1)
        const sanitizedAx = Math.abs(this.smoothAx);

        // 3) same atan2 but with sanitized
        const raw = Math.atan2(this.smoothAy, -sanitizedAx);
        const display = raw - Math.PI / 2;
        (_this$bubbleUtils$arr3 = this.bubbleUtils.arrow) === null || _this$bubbleUtils$arr3 === void 0 || _this$bubbleUtils$arr3.setRotation(display);
        (_this$bubbleUtils$ini3 = this.bubbleUtils.initialBubble) === null || _this$bubbleUtils$ini3 === void 0 || _this$bubbleUtils$ini3.setRotation(display);
        this.bubbleUtils.updateProjectionLine(display);
        this.bubbleUtils.updateProtractorArc(display);
        if (((_this$selectedCogFire3 = this.selectedCogFireBlock) === null || _this$selectedCogFire3 === void 0 ? void 0 : _this$selectedCogFire3.block) === "fire") {
          var _publishedDataAnalyse3;
          const isCogButtonPressed = (_publishedDataAnalyse3 = connectedCog.publishedDataAnalyser.cogState) === null || _publishedDataAnalyse3 === void 0 ? void 0 : _publishedDataAnalyse3.buttonClick;
          if (isCogButtonPressed === "click" && ay > 0 && !this.isShooting) {
            this.bubbleUtils.shootBubble(this);
            this.isShooting = true;
          } else if (isCogButtonPressed === "release") {
            this.isShooting = false;
          }
        }
      }
      if (((_this$selectedCogTilt7 = this.selectedCogTiltLeftBlock) === null || _this$selectedCogTilt7 === void 0 ? void 0 : _this$selectedCogTilt7.block) === "moveright" && ((_this$selectedCogTilt8 = this.selectedCogTiltRightBlock) === null || _this$selectedCogTilt8 === void 0 ? void 0 : _this$selectedCogTilt8.block) === "moveleft") {
        var _this$bubbleUtils$arr4, _this$bubbleUtils$ini4, _this$selectedCogFire4;
        // when cog is steered left,
        // the arrow rotates wrongly to the right, and when steered right, it rotates to the left. so basically its opposite

        this.smoothAx += this.alpha * (ax - this.smoothAx);
        this.smoothAy += this.alpha * (ay - this.smoothAy);
        // compute raw angle: zero = right, positive = counter-clockwise
        // but since your arrow art apparently points “up” at zero,
        // we’ll rotate by –90° (–π/2) to compensate.
        const raw = Math.atan2(this.smoothAy, this.smoothAx); // radians, zero=right, CCW+
        const display = raw - Math.PI / 2; // shift so that (0,1)→up
        (_this$bubbleUtils$arr4 = this.bubbleUtils.arrow) === null || _this$bubbleUtils$arr4 === void 0 || _this$bubbleUtils$arr4.setRotation(display);
        (_this$bubbleUtils$ini4 = this.bubbleUtils.initialBubble) === null || _this$bubbleUtils$ini4 === void 0 || _this$bubbleUtils$ini4.setRotation(display);
        this.bubbleUtils.updateProjectionLine(display);
        this.bubbleUtils.updateProtractorArc(display);
        if (((_this$selectedCogFire4 = this.selectedCogFireBlock) === null || _this$selectedCogFire4 === void 0 ? void 0 : _this$selectedCogFire4.block) === "fire") {
          var _publishedDataAnalyse4;
          const isCogButtonPressed = (_publishedDataAnalyse4 = connectedCog.publishedDataAnalyser.cogState) === null || _publishedDataAnalyse4 === void 0 ? void 0 : _publishedDataAnalyse4.buttonClick;
          if (isCogButtonPressed === "click" && ay > 0 && !this.isShooting) {
            this.bubbleUtils.shootBubble(this);
            this.isShooting = true;
          } else if (isCogButtonPressed === "release") {
            this.isShooting = false;
          }
        }
      }
    }
  }
}
exports.GameScene = GameScene;